import gql from "graphql-tag";
const createCalcSheetMutation = gql(`
mutation createCalcSheet($params: CalcInput!) {
  createCalcSheet(params: $params) {
  id
  sub
  calculator
  status
  exitcode
  }
}
`)
export default createCalcSheetMutation;
